export default "__VITE_ASSET__15dab190__"